
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 24.733c6.627 0 12-5.536 12-12.366S19.127 0 12.5 0 .5 5.537.5 12.367c0 6.83 5.373 12.366 12 12.366z","fill":"#FB2121"}}),_c('path',{attrs:{"d":"M16.69 17.078l-.38.196c-.382.393-1.143.393-1.524 0L7.547 9.815c-.38-.393-.38-1.178 0-1.57l.19-.197c.382-.392 1.144-.392 1.525 0l7.238 7.46c.571.392.571 1.177.19 1.57z","fill":"#010814"}}),_c('path',{attrs:{"d":"M7.738 17.274l-.19-.196c-.382-.393-.382-1.178 0-1.57l7.238-7.46c.38-.392 1.142-.392 1.523 0l.19.197c.382.392.382 1.177 0 1.57l-7.237 7.46c-.381.392-1.143.392-1.524 0z","fill":"#010814"}})])
          )
        }
      }
    